import React from "react";
import Modal from "sushiweb/Modal";
import Button from "sushiweb/Button";
import styles from './VegMode.module.scss';

const VegModeModal = ({
  visible,
  onClose,
  selectedPreference,
  onPreferenceSelect,
  onSave,
  isSaving = false,
  preferenceOptions = [],
  modalConfig = {},
}) => {
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      showCloseIcon={true}
      title={
        <div className={styles.modalHeader}>
          {modalConfig.heading || 'Veg Mode Preferences'}
        </div>
      }
      isCentered
      type="default"
      className={styles.vegModeModal}
    >
      <div className={styles.modalDivider} />
      <div className={styles.modalContent}>
        <div className={styles.optionsContainer}>
          {preferenceOptions && preferenceOptions.length > 0 ? (
            preferenceOptions.map((option) => (
              <div
                key={option.key}
                className={`${styles.option} ${
                  selectedPreference === option.key ? styles.selected : ""
                }`}
                onClick={() => onPreferenceSelect(option.key)}
              >
                <div className={styles.radioButton}>
                  {selectedPreference === option.key && (
                    <div className={styles.radioButtonInner} />
                  )}
                </div>
                <span className={styles.optionLabel}>
                  {selectedPreference === option.key && option.selectedLabel
                    ? option.selectedLabel
                    : option.label}
                </span>
              </div>
            ))
          ) : (
            <div className={styles.errorMessage}>
              Something went wrong. Please try again.
            </div>
          )}
        </div>
        <div className={styles.modalBottomDivider} />
        <div className={styles.saveButtonContainer}>
          <Button
            appearance="solid"
            onClick={onSave}
            disabled={!selectedPreference}
            loading={isSaving}
            className="fs-16 w-600"
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VegModeModal;
